export class Performance {
  collected_at!: string;
}
